import React, {useReducer, useState, useEffect} from 'react';
import {Droparea, StyledLabel, StyledForm, StyledInput, StyledText} from './styles.js';
import reducer from '../uploadMiddleware/reducers.js';
import upload from '../uploadMiddleware/middleware.js';
import UploadTasks from './UploadTasks.js';

export default function DropZone({signingUrl, folder, multiple, confirmUpload}) {
    const [state, dispatch] = useReducer(reducer,[]);
    const [data, setData] = useState([]);

    window.addEventListener("message", receiveMessage);
    function receiveMessage(event) {
        if (event.data && event.data.type === "UPLOAD") {
            setData(event.data.message);
        }
    }

    useEffect(() => {
        window.parent.postMessage({ type: "INITIALIZED"}, "*");
    },[]);

   useEffect(() => {
       if (data instanceof FileList) {
        upload({type: 'change', target: { files: data } }, folder, dispatch, {signingUrl, confirmUpload});
       }
    }, [data]);

    function handleFiles(event) {
        upload(event, folder, dispatch, {signingUrl, confirmUpload});
    }

    function handleDrop(event) {
        event.preventDefault();
        event.stopPropagation();
        upload(event, folder, dispatch, {signingUrl, confirmUpload});
    }
    return (
        <Droparea
            onDrop={handleDrop}
            onDragEnter={(e) => {e.preventDefault(); e.stopPropagation()}}
            onDragOver={(e) => {e.preventDefault(); e.stopPropagation()}}
            onDragLeave={(e) => {e.preventDefault(); e.stopPropagation()}}
        >
            <StyledForm>
                <StyledText>Upload multiple files with the file dialog or by dragging and dropping images onto the dashed region</StyledText>
                <StyledInput type="file" id="fileElem" multiple={multiple} accept="image/*" onChange={handleFiles}></StyledInput>
                <StyledLabel htmlFor="fileElem">Select some files</StyledLabel>
            </StyledForm>
            <div>{state.map((task, index) => {
                return <UploadTasks key={`${index}as`} task={task} />
            })}</div>
        </Droparea>
    )
}